import { mapState } from "vuex";
import { CurrencyValue } from "@/components/tableElements";
import PercentageValue from "@/components/tableElements/PercentageValue";
import AppIcon from "@/components/AppIcon.vue";
import Icons from "@/components/icons";
export default {
  name: "PpcBidSimulator",
  components: {
    ...Icons,
    CurrencyValue,
    PercentageValue,
    AppIcon
  },
  props: {
    targeting: {
      type: Object,
      default: {}
    },
    currency: {
      type: String
    },
    focusTargeting: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapState({
      bid_simulator: state => state.ppc_settings.bid_simulator
    })
  },
  data() {
    return {
      targeting_types: ["B.Non-Branded KW", "A.Competitors Product", "C.Branded", "D.Discovery"],
      key_mapping: {
        "B.Non-Branded KW": "non_branded_keyword_targeting",
        "A.Competitors Product": "competitor_product_targeting",
        "C.Branded": "branded_keyword_product_targeting",
        "D.Discovery": "discovery_targeting"
      },
      targetingTypeTitleIconMap: {
        "B.Non-Branded KW": {
          title: "Non-branded type",
          icon: "bid-layout-alt",
          color: "#134890"
        },
        "A.Competitors Product": {
          title: "Competitor’s products",
          icon: "bid-users-up",
          color: "#423994"
        },
        "C.Branded": {
          title: "Branded keywords & products",
          icon: "bid-tag",
          color: "#DB2473"
        },
        "D.Discovery": {
          title: "Discovery targeting",
          icon: "search-refactor",
          color: "#595959"
        }
      },
      precision: 2
    };
  },
  methods: {
    getTargeting(key) {
      let result = this.bid_simulator[key];
      return !!result ? result[0].targeting : 0;
    },
    getCvr(key) {
      let result = this.bid_simulator[key];
      return !!result ? result[0].cvr : 0;
    },
    getProductMargin(key) {
      let result = this.bid_simulator[key];
      return !!result ? result[0].total_weighted_margin_ccy : 0;
    },
    avgMargin(key) {
      let product_margin = this.getProductMargin(key);
      let cvr = this.getCvr(key);
      return product_margin * cvr;
    },
    computedMaxBid(key) {
      let result = this.targeting[this.key_mapping[key]] / 100 * this.avgMargin(key);
      return result;
    }
  }
};